import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  type Unsubscribe,
} from "firebase/firestore";
import { db } from "@/config/firebase";
import type { EditorMessage, EditorServiceJob } from "@/types";

const ACTIVE_JOB_ID = "active";

export function subscribeActiveEditorJob(
  projectId: string,
  onData: (job: EditorServiceJob | null) => void,
  onError?: (error: Error) => void,
): Unsubscribe {
  return onSnapshot(
    doc(db, "projects", projectId, "editor_jobs", ACTIVE_JOB_ID),
    (snap) => {
      onData(snap.exists() ? ({ id: snap.id, ...snap.data() } as EditorServiceJob) : null);
    },
    (error) => onError?.(error),
  );
}

export function subscribeEditorMessages(
  projectId: string,
  onData: (messages: EditorMessage[]) => void,
  onError?: (error: Error) => void,
): Unsubscribe {
  const messagesQuery = query(
    collection(db, "projects", projectId, "editor_messages"),
    orderBy("created_at", "asc"),
    limit(80),
  );

  return onSnapshot(
    messagesQuery,
    (snap) => {
      onData(snap.docs.map((message) => ({ id: message.id, ...message.data() }) as EditorMessage));
    },
    (error) => onError?.(error),
  );
}
